(function () {
    'use strict';

    angular
        .module('core.components')
        .controller('FirstAccessController', FirstAccessController)

    /** @ngInject */
    function FirstAccessController($rootScope, PreRegistrationService, HelperService, AuthenticationService, sweetAlert) {
        const vm = this;

        vm.passwordValidator = AuthenticationService.passwordValidator;

        vm.firstAccess = () => {
            if (!validateDate())
                return;

            HelperService.startLoading('.loading-holder');

            let personData = {
                Name: vm.firstAccessData.Name,
                GenderId: vm.firstAccessData.GenderId,
                BirthDate: vm.firstAccessData.BirthDate.Date,
                Password: Encrypt.Hash(vm.firstAccessData.Password).toString(),
                PreRegisterId: vm.firstAccessData.PreRegisterId
            }

            let personDocuments = vm.firstAccessData.Documents.reduce((acc, cur) => {
                acc.push({
                    DocumentTypeId: cur.DocumentTypeId,
                    Document: cur.Document
                })

                return acc;
            }, []);

            if (!personDocuments.find(x => x.DocumentTypeId == 1)) {
                sweetAlert.swal({
                    title: 'Aviso',
                    text: 'Você também deve informar o seu CPF no cadastro!',
                    type: 'warning',
                    confirmButtonText: 'Ok',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                })

                HelperService.stopLoading('.loading-holder');
                return;
            }

            let personEmails = vm.firstAccessData.Emails.reduce((acc, cur) => {
                acc.push({
                    EmailTypeId: cur.EmailTypeId,
                    Email: {
                        Address: cur.Email.Address
                    }
                })

                return acc;
            }, []);

            let personTelephones = vm.firstAccessData.Telephones.reduce((acc, cur) => {
                acc.push({
                    PhoneTypeId: cur.PhoneTypeId,
                    Phone: {
                        Code: cur.Phone.Code,
                        Number: cur.Phone.Number
                    }
                })

                return acc;
            }, []);

            personData.Person_Document = personDocuments;
            personData.Person_Email = personEmails;
            personData.Person_Phone = personTelephones;

            PreRegistrationService
                .registerPerson(personData)
                .then(success => {
                    if (success) {
                        vm.step = 3;
                        HelperService.stopLoading('.loading-holder');
                    } else {
                        HelperService.errorCallback(success);
                        HelperService.stopLoading('.loading-holder');
                    }
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                })
        }

        vm.getPreRegister = () => {
            HelperService.startLoading('.loading-holder');

            PreRegistrationService
                .getPreRegistration(vm.preRegisterData.PinCode)
                .then(success => {
                    vm.firstAccessData.PreRegisterId = success.Id;
                    vm.firstAccessData.Name = success.Name;
                    vm.firstAccessData.Emails[0] = {
                        Email: {
                            Address: success.Email
                        }
                    };

                    vm.step = 2;

                    $rootScope.authenticationWrapperLarger = true;

                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                })
        }

        init();

        function validateDate() {
            let isBirthdayValid = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(vm.firstAccessData.BirthDate.Formatted);

            if (!isBirthdayValid) {
                HelperService.setErrorMessageForm('.birthday', "Digite uma data válida.");
                return;
            }

            let birthday = angular.copy(vm.firstAccessData.BirthDate.Formatted.replace(/[//"]/g, '-'));

            let birthdaySplitted = birthday.split("-");

            birthday = `${birthdaySplitted[2]}-${birthdaySplitted[1]}-${birthdaySplitted[0]}`;

            vm.firstAccessData.BirthDate.Date = moment(birthday).format('YYYY-MM-DD');

            return true;
        }

        function init() {
            $rootScope.authenticationWrapperLarger = false;
            vm.step = 1;

            vm.preRegisterData = {};

            vm.firstAccessData = {
                Emails: [],
                Telephones: [],
                Documents: []
            };

            vm.dateRegex = '';
        }
    }
}());